import { Box, Typography } from "@mui/material";

import { ColorsProfileActivity } from "../../../utils/constants/colors";

type TProfileActivityTag = {
    name: string;
    abbreviation: string;
};

function ProfileActivityTag({ abbreviation, name }: TProfileActivityTag) {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "2.5rem",
                width: "2.5rem",
                borderRadius: "50%",
                backgroundColor: ColorsProfileActivity(name),
                border: "2px solid #FFF",
            }}
        >
            <Typography
                sx={{
                    color: "#FFF",
                    textAlign: "center",
                    fontFamily: "Noto Sans",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    lineHeight: "1.25rem",
                    letterSpacing: "0.0088rem",
                }}
            >
                {abbreviation}
            </Typography>
        </Box>
    );
}

export default ProfileActivityTag;
